import {useAddress} from "@thirdweb-dev/react";
import { useState, useEffect } from "react";
import { lensClient } from "../client/LensClient";
import { isRelaySuccess } from "@lens-protocol/client";
import { ethers } from "ethers";

import { toast} from 'react-toastify';

import "./followStyles.css";

export function UseFollow({id}) {
    const ide = {id}
    //console.log(ide.id);
    const address = useAddress();
    const [userID,setUserID] = useState();

    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();

    useEffect(()=>{
      async function fetchProfileId(){
        const profiles = await lensClient.profile.fetchAll({
          where: {
            ownedBy: [address],
          },
        })
        if(profiles.items.length!=0){
          setUserID(profiles?.items[0].id);
        }
      }
      fetchProfileId();
    },[])
    // v1 method for follow
  //   useEffect(()=>{
  //       async function follow(){
  //         if(data){
  //         const result = data.createFollowTypedData;
  //         const typedData = result.typedData;
  //         if (!sdk) return;
  //         //Sign the typed data using the SDK
  //         const signature = await signTypedDataWithOmmittedTypename(sdk,typedData.domain, typedData.types, typedData.value)
  //         const { v, r, s } = splitSignature(signature.signature);
  //         //Send the typed data to the smart contract to perform the
  //         // write operation on the blockchain
  //         const lensHubContract = await sdk.getContractFromAbi(
  //           LENS_CONTRACT_ADDRESS,
  //           LENS_CONTRACT_ABI
  //         );
  //         // Call the smart contract function called "followWithSig"
  //         const tx = await lensHubContract.call("followWithSig",{
  //           follower: address,
  //           profileIds: typedData.value.profileIds,
  //           datas: typedData.value.datas,
  //           sig: {
  //             v,
  //             r,
  //             s,
  //             deadline: typedData.value.deadline,
  //           },
  //         });
  //         toast.info("Following",{
  //           position:toast.POSITION.TOP_CENTER
  //         })
  //     }
  //     else{
  //       console.log("no data");   
  //     }
  //   }
  //   follow();
  // })

    // const [followProfile, { data, loading, error }] = useMutation(
    //     FOLLOW_QUERY,
    //     {
    //       onCompleted: () => {
    //         console.log("Following");
    //       },
    //       onError: (error) => {
    //         console.log("Error", error);
    //       },
    //     }
    //   );
     
      async function handlefollow(){
        const profiles = await lensClient.profile.fetchAll({
          where: {
            ownedBy: [address],
          },
        })
        if(profiles.items.length===0){
            toast.info("Please Sign Up or Create Your Profile.",{
              position:toast.POSITION.TOP_CENTER
             })
          }
        else{

          setUserID(profiles?.items[0].id);
          const { id:authID, text } = await lensClient.authentication.generateChallenge({
          signedBy:address,
          for:userID, // e.g "0x01"
        });
        const signature = await signer.signMessage(text); // text returned from authentication.generateChallenge
        await lensClient.authentication.authenticate({ id:authID, signature:signature});
       
        // your LensClient instance must be authenticated
        const result = await lensClient.profile.follow({
          follow: [
            {
              profileId: id[0],
            },
          ],
        });
        
        const followResultValue = result.unwrap();
        
        if (!isRelaySuccess(followResultValue)) {
          toast.info("Something went wrong",{
            position:toast.POSITION.TOP_CENTER
          })
          console.log(`Something went wrong`, followResultValue)
          return
        }
        
        await lensClient.transaction.waitUntilComplete({
          forTxId: followResultValue.txId,
        });

        toast.success(<div>You are now Following "{id}.</div>,{
          position:toast.POSITION.TOP_CENTER
        })
      }
    }
    return(
        <div className = "followBtn">
            <button onClick={async () => await handlefollow()}>Follow</button>
        </div>
        );

}
